import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { selectItemById, getMedicalConditionTypeById, updateMedicalConditionType } from 'app/redux/store/features/medcond'
import utilServices from 'app/services/util-services'
import UpdateMedicalConditionTypeForm from './UpdateMedicalConditionTypeForm'

const UpdateMedicalConditionType = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const [apiCallInProgress, setApiCallInProgress] = useState(false)
    const { state } = useLocation()
    const { id } = state
    const { list, loading, error } = useSelector((s) => s.medcond)
    const medicalConditionType = selectItemById(list, id)

    useEffect(() => {
        if (utilServices.isNullOrUndefined(medicalConditionType.id)) dispatch(getMedicalConditionTypeById({ id: id }))
    }, [])

    useEffect(() => {
        if (!apiCallInProgress || loading) return
        setApiCallInProgress(false)

        if (error) handleError(error)
        else {
            enqueueSnackbar('Medical condition type updated successfully', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
            navigate('/settings/definitions/medical-condition-type')
        }
    }, [loading])

    function handleError(err) {
        if (err.status === '401') {
            navigate('/profile/signout')
        } else if (err.detail) {
            enqueueSnackbar(err.detail, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        } else {
            enqueueSnackbar(err, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        }
    }

    const onUpdate = async () => {
        setApiCallInProgress(true)
        dispatch(updateMedicalConditionType({ ...medicalConditionType }))
    }

    return (
        <React.Fragment>
            <UpdateMedicalConditionTypeForm
                medicalConditionTypeData={medicalConditionType}
                updateMedicalConditionType={onUpdate}
            />
        </React.Fragment>
    )
}

export default UpdateMedicalConditionType
